import * as msal from "@azure/msal-browser"

const msalConfig: msal.Configuration = {
  auth: {
    clientId: `${process.env.REACT_APP_CLIENT_ID}`,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
}

export const msalInstance = new msal.PublicClientApplication(msalConfig)

export const loginRequestConfigs = {
  scopes: ["User.Read"],
}
